import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';

export default function Surface({ children, variant = 'default', ...rest }) {
  const bg = useColorModeValue(
    variant === 'muted' ? 'rgba(255,255,255,0.72)' : 'rgba(255,255,255,0.92)',
    variant === 'muted' ? 'rgba(18, 25, 46, 0.78)' : 'rgba(16, 23, 40, 0.88)',
  );
  const borderColor = useColorModeValue(
    'rgba(162, 176, 210, 0.18)',
    'rgba(255, 255, 255, 0.08)',
  );
  const shadow = useColorModeValue(
    variant === 'elevated'
      ? '0 28px 80px rgba(34, 57, 124, 0.14)'
      : '0 18px 50px rgba(34, 57, 124, 0.10)',
    variant === 'elevated'
      ? '0 30px 80px rgba(2, 8, 23, 0.42)'
      : '0 22px 54px rgba(2, 8, 23, 0.28)',
  );

  return (
    <Box
      bg={bg}
      backdropFilter="blur(20px)"
      border="1px solid"
      borderColor={borderColor}
      borderRadius={{ base: '24px', xl: '28px' }}
      boxShadow={shadow}
      {...rest}
    >
      {children}
    </Box>
  );
}
